<template>
  <div class="room-quantity">
    <label>{{ $t('h4h.roomNum') }}</label>
    <div class="counter">
      <span
        :class="[disableSubtraction ? 'disable' : '', 'subtract']"
        @click="updateQuantity(-1, 'subtract')"
      />
      <span class="number-of-rooms">
        {{ quantity }}
      </span>
      <span
        :class="[disableAddition ? 'disable' : '', 'add']"
        @click="updateQuantity(1, 'add')"
      />
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  props: {
    contracted: {
      default: false,
      type: Boolean
    }
  },

  computed: {
    quantity() {
      return this.$store.state.hotel.roomQty
    },
    disableSubtraction() {
      return this.quantity < 2
    },
    disableAddition() {
      if (this.contracted) {
        return this.$store.state.hotel.roomQty >= this.$store.state.packages.packageQty
      } else {
        return false
      }
    }
  },

  methods: {
    ...mapMutations(['updateRoomQty']),
    updateQuantity(value, operation) {
      switch (operation) {
      case 'add':
        if (!this.disableAddition) {
          this.updateRoomQty(value)
        }
        break

      case 'subtract':
        if (!this.disableSubtraction) {
          this.updateRoomQty(value)
        }
        break
      }
    }
  }
}
</script>
